var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-block text-light d-flex justify-content-between shadow",on:{"click":_vm.toggle_ui}},[_c('span',{staticClass:"mr-3"},[_vm._v("Hide UI")]),_c('span',[_vm._v("\"U\"")])])}
var staticRenderFns = []

export { render, staticRenderFns }